module.exports = __webpack_public_path__ + "img/L_KH.bc140f23.png";